import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Container, Header, Title } from '~/components';
import { productFruitsIds } from '~/constants/productFruits';
import { routes } from '~/providers/RouterProvider/router.routes';
import { srOnlyStyle } from '~/styles/utilities.css';

import { ProductInfoCard } from './ProductInfoCard';
import { cardsStyle } from './ProductsOverview.css';
import { ProductsTable } from './ProductsTable';

export const ProductsOverview = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['products']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('products:header.title')} />

        <Header.Actions>
          <Header.Action
            data-pf-id={productFruitsIds.products.header.createProduct}
            icon="Add"
            onClick={() => navigate(routes.createProduct)}
          >
            {t('products:header.actionBlock.button')}
          </Header.Action>
        </Header.Actions>
      </Header.Root>

      <Container>
        <Title as="h2" className={srOnlyStyle}>
          {t('products:overview.infoCard.title')}
        </Title>

        <div className={cardsStyle}>
          <ProductInfoCard
            description={t('products:overview.infoCard.products.description')}
            icon="Package"
            link={{ href: t('products:overview.infoCard.products.href'), label: t('products:overview.infoCard.products.label') }}
            title={t('products:overview.infoCard.products.title')}
          />

          <ProductInfoCard
            description={t('products:overview.infoCard.instantInvoices.description')}
            icon="HourglassBottom"
            link={{
              href: t('products:overview.infoCard.instantInvoices.href'),
              label: t('products:overview.infoCard.instantInvoices.label'),
            }}
            title={t('products:overview.infoCard.instantInvoices.title')}
          />
        </div>

        <ProductsTable />
      </Container>
    </>
  );
};
